import CookieUniversal from 'cookie-universal';
import cookieConfig from '~/assets/services/storages/cookies/cookie.config';

const cookies = new CookieUniversal();
const cookieNamePrefix = 'CastoramaStatement';
const cookieMaxDays = 5;
const cookieDefaultValue = 1;

function set({ id, value = cookieDefaultValue }) {
    cookies.set(`${cookieNamePrefix}-${id}`, value, {
        ...cookieConfig.defaultOptions,
        maxAge: 60 * 60 * 24 * cookieMaxDays,
    });
}

function getState({ id, value = cookieDefaultValue }) {
    return cookies.get(`${cookieNamePrefix}-${id}`) === value;
}

export { set, getState };
